var map = {
	"./en-GB": [
		"fb06"
	],
	"./en-GB.js": [
		"fb06"
	],
	"./i18n": [
		"0692"
	],
	"./i18n.js": [
		"0692"
	],
	"./pl": [
		"9ef7",
		"lang-pl"
	],
	"./pl.js": [
		"9ef7",
		"lang-pl"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2e98";
module.exports = webpackAsyncContext;